import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import { isBrowser, useScript } from '@jelly/utils'

// Styled Components via Emotion
const IframeWrapper = styled.div`
	margin: 0 auto;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		max-width: 50%;
	}
`

PardotForm.propTypes = {
	height: string,
	src: string.isRequired,
	title: string,
	width: string,
}

/**
 * This Component is the PardotForm
 * The fields and styles are controlled via Salesforce
 */
function PardotForm({ height = '1000', src, title = 'Pardot Form', width = '100%' }) {
	if (isBrowser()) {
		window.piAId = '901901'
		window.piCId = '3311'
		window.piHostname = 'pi.pardot.com'
	}
	useScript('https://pi.pardot.com/pd.js')

	return (
		<IframeWrapper id="pardot-form">
			<iframe
				allowtransparency="true"
				frameBorder="0"
				height={height}
				src={src}
				style={{ border: 0 }}
				title={title}
				type="text/html"
				width={width}
			></iframe>
		</IframeWrapper>
	)
}

export default PardotForm
